module.exports = __webpack_public_path__ + "static/media/1007017.9176995f.jpg";